import _ from 'lodash';

import { dashboard } from 'types';
import { payloadToJSON, toJSON, toJSONArray } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

interface TurnTimesMap {
  [turnTimeId: number]: dashboard.TurnTime;
}

interface State {
  turnTimes: TurnTimesMap;
  isInitialized: boolean;
  requestInProgress: boolean;
  serviceTurnTimes: dashboard.TurnTime[];
}

const initialState: State = {
  turnTimes: {},
  isInitialized: false,
  requestInProgress: false,
  serviceTurnTimes: [],
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.TURN_TIMES_FETCH_ALL_STARTING:
    case AppConstants.TURN_TIMES_FETCH_FOR_SERVICE_DAY_STARTING: {
      return {
        ...state,
        isInitialized: false,
      };
    }
    case AppConstants.TURN_TIMES_FETCH_ALL_DONE: {
      const jsonPayload = toJSONArray<dashboard.TurnTime>(payload);
      const turnTimes: TurnTimesMap = {};
      _.forEach(jsonPayload, (turnTime: dashboard.TurnTime) => {
        turnTimes[turnTime.id] = turnTime;
      });
      return {
        ...state,
        turnTimes,
        isInitialized: true,
      };
    }
    case AppConstants.TURN_TIMES_FETCH_FOR_SERVICE_DAY_DONE: {
      return {
        ...state,
        isInitialized: true,
        serviceTurnTimes: toJSONArray<dashboard.TurnTime>(payload),
      };
    }
    case AppConstants.TURN_TIMES_FETCH_ALL_FAILED:
    case AppConstants.TURN_TIMES_FETCH_FOR_SERVICE_DAY_FAILED: {
      return {
        ...state,
        isInitialized: true,
      };
    }
    case AppConstants.TURN_TIMES_UPDATE_STARTING:
    case AppConstants.TURN_TIMES_REPLACE_ALL_STARTING: {
      return {
        ...state,
        requestInProgress: true,
      };
    }
    case AppConstants.TURN_TIMES_UPDATE_FAILED:
    case AppConstants.TURN_TIMES_REPLACE_ALL_FAILED: {
      return {
        ...state,
        requestInProgress: false,
      };
    }
    case AppConstants.TURN_TIMES_UPDATE_DONE: {
      const turnTimes = _.clone(state.turnTimes);
      _.forEach(payload.response, (updateResponse) => {
        const jsonResponse = toJSON<dashboard.TurnTimeUpdateResponse.Response>(updateResponse);
        if (jsonResponse.upsertResponse) {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          const upsertedItem = jsonResponse.upsertResponse.upserted! as dashboard.TurnTime;
          turnTimes[upsertedItem.id] = upsertedItem;
        } else if (jsonResponse.removeResponse) {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          const removedId = jsonResponse.removeResponse.removed!;
          delete turnTimes[removedId];
        }
      });
      return {
        ...state,
        turnTimes,
        requestInProgress: false,
      };
    }
    case AppConstants.TURN_TIMES_REPLACE_ALL_DONE: {
      const jsonPayload = payloadToJSON<dashboard.TurnTime[]>(payload.replaceResponse.newTurnTime);
      const turnTimes: TurnTimesMap = {};
      _.forEach(jsonPayload, (turnTime: dashboard.TurnTime) => {
        turnTimes[turnTime.id] = turnTime;
      });
      return {
        ...state,
        requestInProgress: false,
      };
    }

    default:
      return state;
  }
}
